var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.selectedFeatures),function(feature){return _vm._l((feature.urls),function(url,index){return _c('LTileLayer',{key:`${feature.key}-${index}`,attrs:{"layer-type":"overlay","url":url,"options":_vm.getOptions(feature.key)}})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }